<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Half Title">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi">SPANISH CINEMA AGAINST ITSELF<span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle1.vue?20957fc6